import { ROOT } from "../config";

export const GET_MEAL_PLAN = (plan: number) => {
  return `${ROOT}/api/meal/plan/${plan}`;
};
